<template>
  <aside class="business-table-sidebar">
    <div class="business-table-sidebar__title">建筑</div>
    <el-tree
      ref="buildingTree"
      class="business-table-sidebar__tree"
      :data="buildList"
      :props="treeProps"
      :expand-on-click-node="false"
      :highlight-current="true"
      default-expand-all
      node-key="id"
      v-loading="loading"
      @node-click="handleNodeClick"
    />
    <el-button
      class="business-table-sidebar__reset"
      size="mini"
      plain
      icon="el-icon-refresh"
      @click="handleReset"
    >
      全部
    </el-button>
  </aside>
</template>

<script>
import { queryBuildTree } from '@/api/archives/building'

export default {
  name: 'BuildingTableSidebar',
  data () {
    return {
      buildList: [],
      loading: false,
      treeProps: {
        children: 'children',
        label: 'buildingName'
      }
    }
  },
  mounted () {
    this.queryBuildTree()
  },
  methods: {
    queryBuildTree () {
      this.loading = true
      queryBuildTree({ page: 1, size: 20000 }).then(res => {
        this.buildList = (res && res.success && res.success.list) || []
      }).catch(() => {
        this.buildList = []
      }).finally(() => {
        this.loading = false
      })
    },
    collectNodeIds (node, ids = []) {
      if (!node) return ids
      if (node.id !== undefined && node.id !== null && node.id !== '') {
        ids.push(node.id)
      }
      const children = node.children || []
      children.forEach(child => this.collectNodeIds(child, ids))
      return ids
    },
    handleNodeClick (node) {
      this.$emit('change', this.collectNodeIds(node).join(','))
    },
    handleReset () {
      if (this.$refs.buildingTree) {
        this.$refs.buildingTree.setCurrentKey(null)
      }
      this.$emit('change', '')
    }
  }
}
</script>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/business/BuildingTableSidebar.vue"
}
</vue-filename-injector>
